<script lang="ts">
	import {
		Icon,
		Indicator,
		Text,
		type IndicatorPropsTypes,
		type NavigationMenuItemPropsTypes,
	} from '@Shelly/shelly-design-system/index';
	import { getSettingsSearchTextSegments } from 'src/helpers/settings/device_settings_search_helpers';

	export let title = '';
	export let subtitle = '';
	export let query = '';
	export let active = false;
	export let disabled = false;
	export let isMobile = false;
	export let premium: NavigationMenuItemPropsTypes['premium'];
	export let notification: IndicatorPropsTypes['type'];

	$: titleSegments = getSettingsSearchTextSegments(title, query);
	$: subtitleSegments = getSettingsSearchTextSegments(subtitle, query);
	$: titleClass = disabled ? 'text-color-3' : active && !isMobile ? 'text-color-black' : '';
</script>

<div class="d-flex flex-direction-column min-width-0">
	{#if title}
		<div class="d-flex gap-s align-items-center min-width-0">
			<Text class={titleClass} styleType="controls-small" noWrap>
				{#each titleSegments as segment}
					{#if segment.highlighted}
						<mark class="settings-search-highlight">{segment.text}</mark>
					{:else}
						{segment.text}
					{/if}
				{/each}
			</Text>
			{#if premium === 'upsell' || premium === 'owned'}
				<Icon
					icon="fas fa-gem"
					size="xs"
					class={premium === 'upsell' ? 'icon-premium-color' : 'text-color-muted'}
				/>
			{/if}
			{#if notification}
				<Indicator type={notification} />
			{/if}
		</div>
	{/if}
	{#if subtitle}
		<Text
			styleType="body-small"
			class={active && !isMobile ? 'text-color-3' : 'text-color-muted'}
			noWrap
		>
			{#each subtitleSegments as segment}
				{#if segment.highlighted}
					<mark class="settings-search-highlight">{segment.text}</mark>
				{:else}
					{segment.text}
				{/if}
			{/each}
		</Text>
	{/if}
</div>

<style>
	.settings-search-highlight {
		padding: 0 2px;
		border-radius: 2px;
		background: rgba(var(--color-primary-1-rgb, 0, 123, 255), 0.3);
		color: var(--color-primary-1);
		font-weight: 600;
	}
</style>
